import { useSideCart } from '@hooks/cart/useShoppingCart';
import Modal from '@monofront/design-system/organisms/Modal';
import FreshCheckAddress from './FreshCheckAddress';

const ModalFreshMobile: React.FC = () => {
  const { sideCart } = useSideCart();

  return (
    <>
      <Modal
        isOpen={sideCart.isOpen && sideCart.shouldAddressBeVerified}
        isClosable={false}
        UNSAFE_className="modal-fresh"
      >
        <FreshCheckAddress />
      </Modal>
      <style jsx>{`
        :global(.modal-fresh) {
          min-height: 100vh;
        }
      `}</style>
    </>
  );
};

export default ModalFreshMobile;
